export class PecVO {
  pec: string;
}
